// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const profoxyColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#F36D00',
}

export const darkTheme = {
  colors: profoxyColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: profoxyColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: profoxyColors.primaryGray,
    secondary: profoxyColors.secondaryGray,
    disabled: profoxyColors.grayText,
    link: profoxyColors.secondaryGray,
    hint: profoxyColors.white,
    highlight: profoxyColors.secondary,
    gray: profoxyColors.primaryGray,
    seeAll: profoxyColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: profoxyColors.primaryGray,
    gray: profoxyColors.secondaryGray,
  },
  filter: {
    primary: profoxyColors.primaryGray,
    secondary: profoxyColors.secondaryGray,
    disabled: profoxyColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: profoxyColors.dark,
    color: profoxyColors.white,
    border: profoxyColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: profoxyColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: profoxyColors.dark,
        selected: profoxyColors.dark,
        progress: rgba(profoxyColors.primary, 0.3),
        past: rgba(profoxyColors.primary, 0.3),
        pastSelected: profoxyColors.dark,
        pastHover: profoxyColors.dark,
        empty: '#555555',
        emptyProgress: rgba(profoxyColors.primary, 0.2),
      },
      text: {
        empty: profoxyColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: profoxyColors.white,
    subTitle: profoxyColors.secondaryGray,
    bg: profoxyColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
